import { CashPanel } from './CashPanel'

export const components = {
  cashPanel: CashPanel,
}
